/**
 * 图片资源解析（自 vancheen-b2b 的 utils/asset.js 移植为 Vue 2/webpack 版本）
 * ---------------------------------------------------------------
 * 原版用 Vite 的 import.meta.glob；vue-cli 下改用 require.context。
 * 模板里只需写文件名，例如 asset('hero-banner-1.jpg')。
 */
const ctx = require.context('@/assets/img/newhome/', false, /\.(png|jpe?g|jpeg|webp|svg|gif)$/)

const map = {}
ctx.keys().forEach(p => {
  map[p.split('/').pop()] = ctx(p)
})

export function asset(name) {
  if (!map[name]) {
    // 开发期就能发现写错的图片名
    console.warn('[nh-asset] 未找到图片资源: ' + name)
    return ''
  }
  return map[name]
}

export const imageMap = map

export default asset
